import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import Script from "next/script";
export var JsonLDType;
(function(JsonLDType) {
    JsonLDType["BreadcrumbList"] = "BreadcrumbList";
    JsonLDType["ListItem"] = "ListItem";
    JsonLDType["FaqPage"] = "FAQPage";
    JsonLDType["Question"] = "Question";
    JsonLDType["Answer"] = "Answer";
    JsonLDType["VideoObject"] = "VideoObject";
    JsonLDType["HowTo"] = "HowTo";
})(JsonLDType || (JsonLDType = {}));
export var JsonLdScript = function(param) {
    var schema = param.schema, tagId = param.tagId;
    return /*#__PURE__*/ _jsx(Script, {
        type: "application/ld+json",
        "data-testid": "json-ld-script",
        id: tagId,
        strategy: "beforeInteractive",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(_object_spread({
                "@context": "https://schema.org"
            }, schema), null, 2)
        }
    });
};
